import { render, staticRenderFns } from "./UserGroupSelect.vue?vue&type=template&id=f3cd5ce6"
import script from "./UserGroupSelect.vue?vue&type=script&lang=ts"
export * from "./UserGroupSelect.vue?vue&type=script&lang=ts"
import style0 from "./UserGroupSelect.vue?vue&type=style&index=0&id=f3cd5ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports